import React from 'react';
import { EyeOff } from 'lucide-react';

interface AnonymizedBadgeProps {
  text: string;
}

export const AnonymizedBadge: React.FC<AnonymizedBadgeProps> = ({ text }) => (
  <span className="inline-flex items-center gap-1 px-2 py-1 bg-purple-100 text-purple-800 rounded-md text-sm">
    <EyeOff className="w-3 h-3" />
    <span>{text} Anônimo</span>
  </span>
);